import styled from "styled-components";
import { Box, darken } from "@mui/material";
import { TemplateColorObject } from "../../../../../InvitationColorMatrix";

export const EnvelopeEntranceWrapper = styled(Box)<{ colormatrix: TemplateColorObject }>`
	position: absolute;
	z-index: 3;
	width: 100%;
	max-width: 430px;
	height: 100vh;
	overflow: hidden;
	display: flex;
	justify-content: center;
	align-items: center;
	flex-direction: column;
	transition: opacity 6s ease-in-out;
	box-sizing: border-box;

	@media only screen and (max-height: 667px) {
		padding-top: 150px;
	}
	@media only screen and (max-height: 586px) {
		padding-top: 100px;
	}

	${props => props.theme.breakpoints.down("sm")} {
		width: 100%;
	}
	background: ${props => props.colormatrix.entrance.background};

	&.show {
		opacity: 1;
		cursor: pointer;
	}

	&.hide {
		opacity: 0;
		z-index: -1;
		cursor: unset;
	}

	&.preview {
		position: relative;
		width: 100%;
		max-width: 320px;
		height: 600px;
		border-radius: 16px;
		overflow: hidden;
		margin: 0 auto;
		cursor: default;
	}

	.seal {
		position: absolute;
		z-index: 3;
		display: flex;
		justify-content: center;
		align-items: center;
		width: 300px;
		height: 200px;
		img {
			width: 120px;
		}
		.initials {
			display: flex;
			justify-content: center;
			align-items: center;
			gap: 3px;
			position: absolute;
			svg {
				fill: #fff;
				width: 15px;
			}

			p {
				font-family: var(--satisfy), sans-serif;
				font-weight: bold;
				font-size: 20px;
				color: #fff;
				&.ar {
					font-size: 15px;
				}
				&.initial {
					font-size: 26px;
					&.ar {
						font-size: 28px;
					}
				}
			}
		}
	}
	.animation_wrapper {
		height: 200px;
		width: 280px;
		position: relative;
		display: flex;
		justify-content: center;
		z-index: 0;
		box-sizing: border-box;
		background-color: ${props => props.colormatrix.entrance.envelope_background};
	}

	.tab_continue_container {
		display: flex;
		flex-direction: column;
		align-items: center;
		gap: 15px;
		position: relative;
		//z-index: 2;
		margin-top: 70px;
		//bottom: 80px;
		//@media only screen and (min-height: 667px) {
		//	bottom: 120px;
		//}
		.tab_continue {
			//border: 1px solid #5e5e5e;
			box-shadow: 0 0 6px 1px ${props => darken(props.colormatrix.main, 0.3)};
			border-radius: 50px;
			padding: 20px;

			svg {
				fill: ${props => darken(props.colormatrix.main, 0.3)};
			}
		}
		.tab_continue_text {
			font-family: var(--poppins), sans-serif;
			font-weight: bold;
			color: ${props => darken(props.colormatrix.main, 0.2)};
		}
	}

	.lid {
		position: absolute;
		height: 100%;
		width: 100%;
		top: 0;
		left: 0;
		border-right: 130px solid transparent;
		border-bottom: 100px solid transparent;
		border-left: 150px solid transparent;
		transform-origin: top;
		transition: transform 0.25s linear;
		box-sizing: border-box;
	}

	/* Lid when closed */

	.lid.one {
		//border-top: 100px solid #eca250;
		transform: rotateX(0deg);
		z-index: 3;
		transition-delay: 0.75s;
		box-sizing: border-box;
	}

	/* Lid when opened */

	.lid.two {
		transform: rotateX(90deg);
		z-index: 1;
		transition-delay: 0.5s;
		box-sizing: border-box;
	}
	.lid {
		border-top: ${props => props.colormatrix.entrance.lid};
	}

	//.lid.template01 {
	//	border-top: 100px solid #eca250;
	//}
	//
	//.lid.template02 {
	//	border-top: 100px solid #962171;
	//}
	//
	//.lid.template03 {
	//	border-top: 100px solid #a24646;
	//}
	//
	//.lid.template04 {
	//	border-top: 100px solid #abdaaf;
	//}

	.envelope {
		position: absolute;
		height: 100%;
		width: 100%;
		top: 0;
		left: 0;
		border-top: 100px solid transparent;

		z-index: 3;
		box-sizing: border-box;
		${props => props.colormatrix.entrance.envelope}
	}

	.letter {
		position: absolute;
		top: 0;
		width: 80%;
		height: 80%;
		background-color: white;
		border: 1px solid #eee;
		border-radius: 15px;
		z-index: 2;
		transition: 0.5s;
	}

	.letter {
		p {
			text-align: center;
			margin-top: 5px;
			color: #3b4049;
		}

		.wedding_of {
			font-family: var(--roboto), sans-serif;
			font-size: 18px;
		}

		.couples {
			font-family: var(--inriaSerif), sans-serif;
			font-size: 24px;
		}
	}

	.animation_wrapper.open .lid.one {
		transform: rotateX(90deg);
		transition-delay: 0s;
	}

	.animation_wrapper.open .lid.two {
		transform: rotateX(180deg);
		transition-delay: 0.25s;
	}

	.animation_wrapper.open .letter {
		transform: translateY(-80px);
		transition-delay: 0.5s;
	}
`;
